import services from "./index";
import store from "@/store";
import qs from "querystring";

export default {
    createPaymentSession(request) {
        return services.http.post(`/v1.0/checkout/create-session`, request);
    },
    
}